import React from 'react';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Atom, withMeta, withSystem, Plugins} from '@packages/systems/wfdl';
import {TList, TElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {defaultParagraphChildrenNodePojo} from '@packages/systems/core/constants/DomNodeDefaults';
import {getChildren} from '@packages/utilities/data-utils';
const basicPlugin = Plugins.name('Basic');

const Paragraph = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <p {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </p>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Paragraph',
  icon: {type: 'Component', value: [basicPlugin, iconName('Paragraph')]},
  showEmpty: true,
  render: Paragraph,
  fields: {
    children: withSystem(
      {
        isBindable: true,
        label: 'Text',
        defaultValue: defaultParagraphChildrenNodePojo,
      },
      TList(
        withMeta(
          {
            multiLine: true,
          },
          TElement
        )
      )
    ),
  },
});

export default config;
